import CustomLink from "components/CustomLink";
import CustomTable from "components/CustomTable";
import CustomText from "components/typography/CustomText";
import moment from "moment";

export default function DeliveryTicketTable({ data = [] }) {
  return (
    <div>
      <CustomTable
        data={data}
        height={750}
        pageCount={50}
        columns={[
          {
            label: "OrderId",
            selector: "orderId",
            cellCSS: "p-2",
            sortValue: (row) => +row?.consignmentReference ?? "",
            cell: (row) => (
              <CustomText variant="body2">
                {row?.consignmentReference ?? ""}
              </CustomText>
            ),
          },
          {
            label: "Date Created",
            selector: "created_at",
            sortValue: (row) => moment(row.createdDateTime).unix(),
            cell: (row) => (
              <CustomText variant="body2">
                {moment(row.createdDateTime).format("YYYY-MM-DD HH:mm")}
              </CustomText>
            ),
          },
          {
            label: "Customer",
            selector: "customer",
            sortValue: (row) => row?.receiver?.name ?? "",
            cell: (row) => (
              <CustomText variant="body2">
                {row?.receiver?.name ?? ""}
              </CustomText>
            ),
          },
          {
            label: "Address",
            selector: "address",
            sortValue: (row) =>
              `${row?.receiver?.address.street} ${row?.receiver?.address.suburb} ${row?.receiver?.address.town} ${row?.receiver?.address.postCode}`,
            cell: (row) => {
              const { street, suburb, town, postCode } =
                row?.receiver?.address ?? {};
              return (
                <CustomText variant="body2">
                  {`${street} ${suburb} ${town} ${postCode}`}
                </CustomText>
              );
            },
          },
          {
            label: "Status",
            selector: "status",
            cell: (row) => (
              <CustomText variant="body2">{row?.status ?? ""}</CustomText>
            ),
          },
          {
            label: "Tracking Link",
            selector: "actions",
            cell: (row, rowIndex) => {
              // const length = 12 - row.consignmentReference.toString().length;
              // const zeroLength = "0".repeat(length);
              // const consignmentIdentifier = `${zeroLength}${row.consignmentReference}`;
              return (
                <CustomLink
                  color="primary"
                  to={`https://www.posthaste.co.nz/phl/servlet/ITNG_TAndTServlet?page=1&customer_number=1941877&consignment_id=${row.consignmentReference}&request_id=3`}
                  target="_blank"
                >
                  <CustomText className="py-3" color="primary" bold>
                    View Tracking
                  </CustomText>
                </CustomLink>
              );
            },
          },
        ]}
      />
    </div>
  );
}
